<template>
  <el-form
    type="textarea"
    ref="form"
    :model="form"
    label-position="left"
    :rules="rules"
    label-width="150px"
    style="padding-top: 25px; padding-left: 20px"
  >
    <el-form-item label="Nombre de Album" style="font-weight: bold" prop="name">
      <el-input v-model="form.name" style="width: 80%"></el-input>
    </el-form-item>
    <el-form-item
      label="Descripción"
      style="font-weight: bold"
      prop="description"
    >
      <el-input v-model="form.description" style="width: 80%"></el-input>
    </el-form-item>
    <el-form-item>
      <el-button @click="HandlerCancel">Cancelar</el-button>
      <el-button type="primary" @click="HandlerSave" v-loading="savingOnServer"
        >Crear</el-button
      >
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  props: {
    albumType: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data() {
    return {
      savingOnServer: false,
      form: { name: "", description: "" },
      rules: {
        name: [
          {
            required: true,
            message: "Debe de especificar un nombre",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    HandlerCancel() {
      this.$emit("close");
    },
    HandlerSave() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.savingOnServer = true;
          let newAlbum = {
            CompanySelected: this.$store.state.user.user.CompanySelected,
            Name: this.form.name,
            Descripcion: this.form.description,
            AlbumType: this.albumType
          };
          this.$http
            .post("/api/gallery/NewAlbum", newAlbum)
            .then(() => {
              this.$emit("close");
              this.$emit("success");
            })
            .catch((er) => {
              console.error(er);
              this.$message.erro("Error al crear el album");
            });
          setInterval(() => {
            this.savingOnServer = false;
          }, 5000);
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style></style>
